import { useDemoMinskogStore } from '../../store/DemoMinskogStore';
import {
    Button,
    Text,
  } from "@ui-component-library";

import { DynamicModal } from '@components/DynamicModal';

export default function DemoBlockDialog() {
    const {isDemo, setDemoBlockPopup, demoBlockPopup} = useDemoMinskogStore()
    if(!isDemo || !demoBlockPopup){
        return null;
    }
  return <>
    <DynamicModal bp={{ sm: 'dialog', lg: 'dialog' }} isOpen={true} onClose={() => {setDemoBlockPopup(null)}}>
        <DynamicModal.Header>
            <Text variant="text-base/leading-normal/medium">{demoBlockPopup.heading}</Text>
        </DynamicModal.Header>
        <DynamicModal.Content>
            <Text variant="text-sm/leading-normal/normal">{demoBlockPopup?.message}</Text>
        </DynamicModal.Content>
        <DynamicModal.Footer>
        <Button variant="outline" onClick={() => {setDemoBlockPopup(null)}}>Stäng</Button>
        <Button onClick={() => {window.location.href = "/min-skog/"}}>Gå till min skog</Button>
        </DynamicModal.Footer>
    </DynamicModal>
  </>
}
